import {Component} from '@angular/core';
import {Region} from "@biletix/core/common";
import {RegionService} from "@biletix/core/services/region.service";
import {AbstractionComponent} from "@biletix/core/common/abstraction-component";

/**
 * Anasayfa header'ındaki bölge (Türkiye / Marmara / İç Anadolu…) çipi.
 *
 * Yalnızca mobil uygulama modunda (`.mobile-app-mode`) görünür; web/masaüstünde bölge
 * seçimi üst banttaki (`btx-wide-top-band`) ve hamburger menüdeki seçicilerden yapılır,
 * bu bileşen orada `display: none` kalır. Eskiden mobil app bu çipi injected script ile
 * (`notificationBellScript.setupRegionButton`) header'a `position: fixed` olarak ekliyor
 * ve seçimi native bir alt sayfada yapıyordu; artık çip de seçim de burada.
 *
 * Seçim `RegionService.changeRegion` ile yapılır: URL'deki bölge segmenti değiştirilip
 * sayfa yenilenir (`/anasayfa/TURKIYE/tr` → `/anasayfa/ISTANBUL/tr`). Mobil app yeni URL'den
 * bölgeyi okuyup bir sonraki açılış için saklar; native köprü mesajı gerekmez.
 */
@Component({
    standalone: false,
    selector: 'btx-wide-region-selector',
    templateUrl: './region-selector.component.html',
    styleUrls: ['./region-selector.component.scss']
})
export class WideRegionSelectorComponent extends AbstractionComponent {

    regions: Region[];
    currentRegion: Region;

    constructor(private regionService: RegionService) {
        super();
        this.regions = this.regionService.getRegions();
        this.currentRegion = this.regionService.currentRegion;

        // RegionGuard, /anasayfa/:region rotası aktifleşince use(region) çağırır → etiket güncel kalsın
        this.regionService.regionChange
            .pipe(this.takeUntilDestroy())
            .subscribe(region => this.currentRegion = region);
    }

    /** Çipe sığacak kısa etiket: `main.region.marmara` ("İstanbul / Marmara") → `main.regionShort.marmara` ("Marmara") */
    shortLabelKey(region: Region | undefined): string {
        return (region?.displayName ?? 'main.region.turkey').replace('main.region.', 'main.regionShort.');
    }

    isCurrent(region: Region): boolean {
        return region.name === this.currentRegion?.name;
    }

    changeRegion(region: Region): void {
        if (this.isCurrent(region)) {
            return;
        }
        this.currentRegion = region;
        this.regionService.changeRegion(region);
    }
}
